module.exports = __webpack_public_path__ + "img/how-to-navigate-1.9c460648.jpg";